<template>
    <section class="app-main">
        
        <div class="top-bar">

            <el-input placeholder="输入订单号查询" v-model="searchVal" @change="search" style="width:300px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table :data="tableData"  height="600" style="width: 100%">
                <el-table-column type="selection" align="center" width="60" fixed="left"></el-table-column>
                <el-table-column prop="title" label="订单号"  align="center" width="200"></el-table-column>
                <el-table-column prop="sname" label="下单账号"  align="center" width="160"> 
                    <template slot-scope="scope">
                        <span
                        v-if="scope.row.phone != ''"
                        style="color: #409eff"
                        >{{ scope.row.phone }}</span
                        >
                        <span v-else-if="scope.row.email != ''" style="color: #409eff">{{
                        scope.row.email
                        }}</span>
                        <span v-else-if="scope.row.order_logistics.tel != ''" style="color: #409eff">
                        {{scope.row.order_logistics.tel}}
                        </span>
                        <span v-else style="color: #409eff">
                        {{scope.row.order_logistics.email}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_time_date" label="下单时间"  align="center" width="160"> </el-table-column>
                <el-table-column prop="deliverymode" label="配送方式"  align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.delivery_method_title=='邮寄'" style="color: #409eff;">{{scope.row.delivery_method_title}}</span>
                        <span v-else-if="scope.row.delivery_method_title=='自提'" style="color: rgb(40, 202, 7);">{{scope.row.delivery_method_title}}</span>
                        <span v-else style="color: rgb(40, 202, 7);">{{scope.row.delivery_method_title}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="所属商家"  align="center" width="180"> 
                    <template slot-scope="scope">
                        <el-button type="primary">{{scope.row.merchant.title}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="type_name" label="支付方式" align="center" width="120" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.pay_method_title == '微信'"  style="color:green">
                            {{scope.row.pay_method_title}}
                        </span>
                        <span v-else-if="scope.row.pay_method_title == '支付宝'" style="color: #409eff;">
                            {{scope.row.pay_method_title}}
                        </span>
                        <span v-else-if="scope.row.pay_method_title == '信用卡'"  style="color:red">
                            {{scope.row.pay_method_title}}
                        </span>
                        <span v-else  style="color:orange">
                            {{scope.row.pay_method_title}}
                        </span>
                    </template>
                </el-table-column>
  
                <el-table-column prop="type_name" label="订单状态" align="center" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.order_status == 0"  style="color:orange">
                            {{scope.row.order_status_title}}
                        </span>
                        <span v-else-if="scope.row.order_status == 1" style="color: #409eff;">
                            {{scope.row.order_status_title}}
                        </span>
                        <span v-else-if="scope.row.order_status == 2"  style="color:orange">
                            {{scope.row.order_status_title}}
                        </span>
                        <span v-else-if="scope.row.order_status == 3"  style="color:green">
                            {{scope.row.order_status_title}}
                        </span>
                        <span v-else-if="scope.row.order_status == 4" style="color:red;">
                            {{scope.row.order_status_title}}
                        </span>
                        <span v-else style="color:orange">
                            {{scope.row.order_status_title}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="total_price" label="商品总价"  align="center" width="160"> </el-table-column>
                <el-table-column prop="actual_price" label="订单总价"  align="center" width="160"> </el-table-column>
                <el-table-column prop="totalMoney"  align="center"  width="170" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="showDetail(scope.row)" type="danger" plain size="small">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" :page-size="20"></el-pagination>
        </el-card>



        


    </section>
</template>



<script>
import { goodsList,goodsSelf_edit } from '@/api/goods.js'
export default {
    data() {
        return {
            selectVal:'',
            searchVal: '',
            tableData:[],
            table_load:false,
            total:0,
            page:1,
        }
    },
    methods: {
        search(){
            if(this.searchVal ==""){
                this.getData()
                return false;
            }
            let params = {
                name:this.searchVal,
                flag:1,
            }
            this.table_load = true;
            goodsList(params).then(res => {
                if(res.status === 1){
                    this.tableData = res.data
                    this.total = res.total
                    this.table_load = false
                    this.tableData.forEach(ele => {
                        ele.img = this.$store.state.url.dev+ele.thumb;               
                    })
                }else{
                    this.tableData = [];
                    this.table_load = false
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false
                console.log(err)
            })
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
                flag:4,
            }
            if(this.searchVal != ""){
                params.name = this.searchVal;
            }
            this.table_load = true;
            goodsList(params).then(res => {
                if(res.status === 1){
                    this.tableData = res.data
                    this.total = res.total
                    this.table_load = false
                    this.tableData.forEach(ele => {
                        ele.img = this.$store.state.url.dev+ele.thumb;               
                    })
                }else{
                    this.tableData = [];
                    this.table_load = false
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false
                console.log(err)
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
        goodsEdit(row,flag){
            let params = {
                flag:flag
            }
            this.table_load = true;
            goodsSelf_edit(row.goods_id,params).then(res => {
                if(res.status === 1){
                    this.$message({message:res.msg,type:'success'})
                    this.table_load = false;
                    this.getData()
                }else{
                    this.tableData = [];
                    this.table_load = false;
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },
        recommend(row,type){
            let params = {
                position_id:type,
            }
            this.table_load = true;
            goodsSelf_edit(row.goods_id,params).then(res => {
                if(res.status === 1){
                    this.$message({message:'设置为你推荐成功',type:'success'})
                    this.table_load = false;
                    row.position_id = type;
                }else{
                    this.table_load = false;
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },
        // 新品首发
        goodsNew(row,type){
            let params = {
                is_new:type,
            }
            this.table_load = true;
            goodsSelf_edit(row.goods_id,params).then(res => {
                if(res.status === 1){
                    this.$message({message:'设置新品首发成功',type:'success'})
                    this.table_load = false;
                    row.is_new = type;
                }else{
                    this.table_load = false;
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

